var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivities = function SvgActivities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 39",
    fill: "#B8B8B8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 17.75H8.125v3.75h18.75v-3.75Zm3.75-13.125H28.75V.875H25v3.75H10V.875H6.25v3.75H4.375a3.733 3.733 0 0 0-3.731 3.75l-.019 26.25a3.749 3.749 0 0 0 3.75 3.75h26.25a3.76 3.76 0 0 0 3.75-3.75V8.375a3.76 3.76 0 0 0-3.75-3.75Zm0 30H4.375V14h26.25v20.625ZM21.25 25.25H8.125V29H21.25v-3.75Z"
  })));
};
export default SvgActivities;